const CURRENCY_MAP = {
  RUB: "₽",
  USD: "$",
  EUR: "€",
  BYN: "Br",
  UZS: "so’m",
  KZT: "₸",
  IDR: "Rp"
};
export {
  CURRENCY_MAP
};
